<footer class="footer" id="fullWidth">
    <div class="content">
        {{ '@copyright' | translate:{ year: currentYear } }} · <a href="https://www.fleethd.com/privacy" target="_blank" rel="noopener">{{'@privacy' | translate}}</a> · <a href="https://www.fleethd.com/terms-of-use" target="_blank" rel="noopener">{{'@termsOfUse' | translate}}</a> · <a href="https://fleethd.statuspage.io">{{'@status' | translate}}</a>
    </div>
    <meta name="insight-app-sec-validation" content="6c465967-0384-43f4-8c3d-ad36d1fa89c7">
</footer>